import {
    baseStates,
    baseMutations,
    baseActions,
    baseGetters,
} from '@/stores/base';

export const preqExpenseType = {

    namespaced: true,

    state:
    {
        ...baseStates,

        url: '/prerequisite/expense-types',

        expenseCategories: [],
        expenseCategoriesLoading: false,
        expenseCategoryLoading: false,
    },

    mutations:
    {
        ...baseMutations,
    },

    actions:
    {
        ...baseActions,
    },

    getters:
    {
        ...baseGetters,

        expenseCategories: state => state.expenseCategories,
    },
};
